<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF BUSINESS MANAGEMENT & COMMERCE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Hospitality Management</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Post Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">MBA (Hospital Management)</td>
                        </tr>
                        <tr>
                            <td class="time">MBA (Pharmaceutical Management)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Hospitality Management</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">MBA (Hospital Management) </b>
                    – The two-year postgraduate MBA in Hospital Management program offered by the ARNI School of
                    Business Management & Commerce addresses the intersection of hospitals, management, and healthcare.
                    Knowledge of several hospital management strategies as well as other business administration
                    strategies like entrepreneurship, healthcare, management, planning, and budgeting are incorporated
                    into this course.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Principles of Management</li>
                    <li> Managerial Economics</li>
                    <li> Business Environment and Law</li>
                    <li> Business Law</li>
                    <li> Research Methodology</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Marketing Strategy and Applications</li>
                    <li> Organization and Administration of Clinical Services</li>
                    <li> Management of National Health Programs</li>
                    <li> Human Resources Management</li>
                    <li> Project/ Seminar</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Healthcare Environment & Management</li>
                    <li> Healthcare Laws, Ethics, and Medical Terminology</li>
                    <li> Patient care Management</li>
                    <li> Hospital Operations Management</li>
                    <li> Internship/Seminar</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Purchase Management & Inventory Control for Hospitals</li>
                    <li> Hospital Information System</li>
                    <li> Management controls systems</li>
                    <li> Foreign Language</li>
                    <li> Project</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">MBA (Pharmaceutical Management)</b>
                    – The ARNI School of Business Management & Commerce's two-year postgraduate MBA in Pharmaceutical
                    Management program focuses on the nexus between management and pharmacy. Among the important topics
                    taught in the MBA program in Pharmaceutical Management are Microbiology, Pharmacology, Basic
                    Epidemiology, Pharma Logistics Management, Strategic Management, and Managerial Communication.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Essentials of Management</li>
                    <li> Management Principles and Organizational Behavior</li>
                    <li> Managerial Economics</li>
                    <li> Financial Management and Statement Analysis</li>
                    <li> Business Environment</li>
                    <li> Organizational Behavior</li>
                    <li> Business Communication and Soft Skills Development</li>
                    <li> Corporate Ethics and Governance</li>
                    <li> Principles of Accounting</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Marketing Management</li>
                    <li> Research Methodology in Management</li>
                    <li> Management Science</li>
                    <li> Product and Brand Manager</li>
                    <li> Pharmacology and Microbiology</li>
                    <li> Pharma Logistics Management</li>
                    <li> Pharmaceutical Marketing and Research</li>
                    <li> Introduction to Physiology and Human Anatomy</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Business Analytics</li>
                    <li> Purchasing and Vendor Management</li>
                    <li> Entrepreneurship</li>
                    <li> Management Information System</li>
                    <li> Pharma Sales and CRM</li>
                    <li> Pharmaco-economics</li>
                    <li> Drug Regulatory Affairs</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Supply Chain Management</li>
                    <li> R & D and Technology Management</li>
                    <li> Healthcare Services Management</li>
                    <li> Semester IV (Electives)</li>
                    <li> Intellectual Property Rights</li>
                    <li> Total Quality Management</li>
                    <li> Pharmaceutical Multinational Management</li>
                    <li> Project/ Seminar</li>

                </ul>
            </div>

        </div>

    </div>
</section>
